// import { Component } from "./Component"

import { FindexFeatureCardSb } from '@/components/findex-connect/types/component-types-sb'

export type FindexFeatureCard = FindexFeatureCardSb & {
  isLastItem?: boolean
}

export const FindexFeatureCard: React.FC<FindexFeatureCard> = ({
  icon,
  text,
  boldText,
  isLastItem,
}) => {
  const regularText = boldText ? text?.split(boldText) : text

  return (
    <div
      className={
        'FEATURE-CARD flex h-[300px] min-w-[300px] shrink-0 basis-4/5 flex-col gap-10 rounded-lg bg-white p-6 md:min-w-[300px] md:basis-[unset] lg:min-h-[320px] lg:min-w-[320px]' +
        (isLastItem ? ` mr-[20%]` : '')
      }
    >
      <div className="ICON-CONTAINER size-[70px] rounded-sm bg-[#FCF5F2] p-1">
        <img
          src={icon?.filename || ''}
          alt={icon?.alt || `${boldText?.split(' ').at(-1)} icon`}
          width={'100%'}
          height={'100%'}
        />
      </div>
      {regularText && (
        <p className="md:para-md">
          {regularText[0]}
          {regularText.length > 1 && <strong className="font-bold">{boldText}</strong>}
          {regularText.length > 1 && regularText[1]}
        </p>
      )}
    </div>
  )
}
